<template>
    <div>
        <vue2-tinymce-editor v-model="content" :init="tinymceConfig"></vue2-tinymce-editor>
    </div>
</template>

<script>
import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
    components: {
        Vue2TinymceEditor,
    },
    data() {
        return {
            content: "",
            tinymceConfig: {
                skin: false,
                // base_url: "/js",
                content_css: false,
                icons: "default",
                height: 300,
                menubar: false,
                branding: false,
                plugins: "lists",
                toolbar: "undo redo | bold italic underline | bullist numlist | removeformat",
                valid_elements: "b,i,u,br,p,ol,ul,li,font,sub,sup",
                valid_styles: {
                    "*": "color,font-size",
                },
                forced_root_block: "p",
                remove_trailing_brs: true,
                entity_encoding: "raw",
                content_style: "body { font-family: Arial, sans-serif; font-size: 14px; }",
                theme: "silver",
            },
        };
    },
    watch: {
        content(newVal) {
            console.log("Contenuto TinyMCE:", newVal);
        },
    },
};
</script>

<style scoped>
.tox-tinymce {
    border-radius: 6px;
}
</style>
